// Constants.
// -----------------------------------------------------------------------------
export const AVATAR_DEFAULT_SIZE = 'm';
export const AVATAR_DEFAULT_DOT = false;
export const AVATAR_DEFAULT_MODE = 'light';
export const AVATAR_DEFAULT_SCHEMA = 'neutral';
export const AVATAR_DEFAULT_VARIANT = 'hard';
// Mappings.
export const AVATAR_SIZE_MAP = {
    l: 48,
    m: 40,
    s: 32,
    '2xl': 64
};
export const AVATAR_SIZE_TO_ICON_SIZE = {
    '2xl': '3xl',
    l: 'xl',
    m: 'l',
    s: 'm'
};
//# sourceMappingURL=Avatar.constants.js.map